import type { FC } from 'react'

import { CoinIcon, type CoinIconVariant } from './CoinIcon'
import { HistoryActionIcon, type HistoryActionIconVariant } from './HistoryActionIcon'

const cx = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ')

export interface HistoryIconRowProps {
  className?: string
}

const ICON_MAPPING: Record<HistoryActionIconVariant, CoinIconVariant> = {
  buy: 'arcs',
  airdrop: 'arcs',
  send: 'arcs',
  receive: 'arcs-ethereum',
}

const ORDER: HistoryActionIconVariant[] = ['buy', 'airdrop', 'send', 'receive']

const OVERLAY_CLASSES = 'absolute -bottom-0 -right-0 size-3.5'

export interface HistoryIconBadgeProps {
  type: HistoryActionIconVariant
  className?: string
  overlayClassName?: string
}

export const HistoryIconBadge: FC<HistoryIconBadgeProps> = ({
  type,
  className,
  overlayClassName,
}) => {
  const coin = ICON_MAPPING[type]

  return (
    <div className={cx('relative inline-flex items-center justify-center', className)} aria-hidden>
      <CoinIcon variant={coin} />
      <HistoryActionIcon type={type} className={cx(OVERLAY_CLASSES, overlayClassName)} />
    </div>
  )
}

export const HistoryIconRow: FC<HistoryIconRowProps> = ({ className }) => {
  return (
    <div
      className={cx(
        'inline-flex items-center gap-6 rounded-[36px] bg-white/80 px-6 py-5 shadow-[0_12px_28px_rgba(15,23,42,0.1)] ring-1 ring-inset ring-white/60 backdrop-blur-[16px]',
        className
      )}
      aria-hidden
    >
      {ORDER.map((type) => (
        <HistoryIconBadge key={type} type={type} />
      ))}
    </div>
  )
}

export default HistoryIconRow
